import React from "react";
import styled from "styled-components";

function PageContentWrapper({ children, ...props }) {
  return (
    <Wrapper {...props}>
      {children}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  height: 100%;
  align-items: center;
  margin-top: 50px;
`;

export default PageContentWrapper;